import { Button as ButtonType, buttonUrl } from '@bw/apis/contentful';
import { cn } from '@bw/core';
import Link from 'next/link';
import { FC } from 'react';
import styles from './Button.module.scss';

export type ButtonProps = {
	data: ButtonType;
	tabIndex?: number;
	isPrimary?: boolean;
	buttonStyle?: 'link' | 'hyperlink';
	onClick?: () => void;
};

export const Button: FC<ButtonProps> = ({
	data: {
		fields: { title },
	},
	tabIndex,
	isPrimary,
	buttonStyle,
	onClick,
}) => {
	return (
		<button
			className={cn(
				styles.button,
				isPrimary && 'accent',
				buttonStyle === 'link' && styles.link,
				buttonStyle === 'hyperlink' && styles.hyperlink
			)}
			onClick={onClick}
			tabIndex={tabIndex}
		>
			{title}
		</button>
	);
};

export const NavigateButton: FC<ButtonProps> = ({
	data,
	isPrimary,
	onClick,
	tabIndex,
}) => {
	return (
		<Link
			className={cn(styles.button, isPrimary && 'accent')}
			href={buttonUrl(data)}
			target="_self"
			onClick={onClick}
			tabIndex={tabIndex}
		>
			{data.fields.title}
		</Link>
	);
};
